/* eslint-disable import/prefer-default-export */

export const companyQueryKeys = {
  addressesV2: (config: Record<string, any>) => ["addressesV2", config],
  addressV2Details: (reference_number: string, config?: any) => ["addressV2", "details", reference_number, config],
  contactBook: (params: { location: string; query?: string; stopIndex?: number }) => ["contactBook", params],
};
